<template>
  <page>
    <template v-slot:table>
      <detailed-n-p-c
        v-if="!loading"
        :entry="data"
        :hide-link="true"
      />
      <v-row
        class="mt-10"
        justify="center"
        v-else
      >
        <v-progress-circular indeterminate />
      </v-row>
    </template>
  </page>
</template>

<script>
import Page from '../components/DatabasePage'
import DetailedNPC from '../components/DetailedNPC'

export default {
  name: 'NPC',
  metaInfo () {
    return {
      title: `${this.loading ? 'Loading...' : this.data.name} - NPCs`,
      meta: [
        {
          name: 'description',
          content: `View detailed and in depth information about ${this.data.name}, a D2R NPC on the Diablo 2 Resurrected database.`
        }
      ]
    }
  },
  components: {
    Page,
    DetailedNPC
  },
  data () {
    return {
      loading: true,
      data: {}
    }
  },
  watch: {
    '$route.params.slug': function () {
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.loading = true

      const req = await this.$http.get(`${process.env.VUE_APP_API_URL}/npcs/${this.$route.params.slug}`)
      this.data = req.data

      this.loading = false
    }
  }
}
</script>
